import React, { useState } from "react";
import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DownloadIcon } from "@/icons";

const Export = ({ name }) => {
  // const theme = useTheme();
  return (
    <>
      <Button
        sx={(theme) => ({
          backgroundColor: theme.palette.BudgieThemeColor.Warning[100],
          minWidth: "auto",
          // border: `1px solid ${theme.palette.BudgieThemeColor.Warning[600]}`,
          color: theme.palette.BudgieThemeColor.Warning[600],
          // boxShadow: `${theme.shadows[1]}`,
          "&:hover": {
            backgroundColor: theme.palette.BudgieThemeColor.Warning[100],
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            border: `1px solid ${theme.palette.BudgieThemeColor.Warning[600]}`,
            borderRadius: "inherit",
            pointerEvents: "none",
          },
        })}
        variant="contained"
        startIcon={<DownloadIcon />}
      >
        {name}
      </Button>
    </>
  );
};

export default Export;
